// extracted by mini-css-extract-plugin
export default {"container":"ComboboxCoso_container__RO2MP","school":"ComboboxCoso_school__CJ4SF","logo":"ComboboxCoso_logo__qLIyg","name":"ComboboxCoso_name__szMP1"};